import { render, staticRenderFns } from "./redeem.vue?vue&type=template&id=73cdf24c&scoped=true&"
import script from "./redeem.vue?vue&type=script&lang=js&"
export * from "./redeem.vue?vue&type=script&lang=js&"
import style0 from "./redeem.vue?vue&type=style&index=0&id=73cdf24c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cdf24c",
  null
  
)

export default component.exports